<template>
    <div class="article">
        <div class="container article__element">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-6 wysiwyg">
                    <h2 class="heading heading--2 article__title">{{ content.title }}</h2>
                    <div class="text">
                        <p>{{ content.firstText }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="content.image" class="container-fluid article__element-image">
            <div class="row">
                <div :class="css">
                    <img :src="`${ this.content.image }`" alt="" class="img-fluid d-none d-md-block">
                    <img :src="`${ this.content.imageMobile }`" alt="" class="img-fluid d-block d-md-none">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["content"],
        computed: {
            css() {
                if(this.content.bigImage) {
                    return 'col-12 col-lg-10 offset-lg-1'
                } else {
                    return 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2'
                }
            }
        }
    }
</script>


